module.exports = __webpack_public_path__ + "img/st_1.1f7b4d4a.jpg";